(function () {
    'use strict';

    angular.module("imApp").factory("businesscoSettingCargonizerService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 352,
                    parameters: parms || {}
                });
            },
            listCargonizerReports: function (parms) {
                return $ihttp.post({
                    method: 2648,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 355,
                    parameters: edit
                });
            },
            getTransportAgreements: function (edit) {
                return $ihttp.post({
                    method: 347,
                    parameters: edit
                });
            },
            saveCargonizerPrinters: function (edit) {
                return $ihttp.post({
                    method: 422,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
